module.exports = __webpack_public_path__ + "img/payment_mb_09.656bcd66.png";